/**
 * Theme API - Access and respond to theme changes
 * @module ThemeAPI
 */

export class ThemeAPI {
  constructor() {
    this.listeners = [];
  }

  /**
   * Get current theme configuration
   * @returns {Promise<object>} Theme data
   */
  async current() {
    try {
      const response = await fetch('/api/theme/current', {
        credentials: 'include'
      });
      
      if (!response.ok) {
        return this.getDefaultTheme();
      }
      
      return await response.json();
    } catch (error) {
      console.warn('[ThemeAPI] Using default theme:', error);
      return this.getDefaultTheme();
    }
  }

  /**
   * Subscribe to theme changes
   * @param {Function} callback - Called when theme changes
   * @returns {Function} Unsubscribe function
   */
  onChange(callback) {
    if (typeof callback !== 'function') {
      throw new Error('Callback must be a function');
    }

    this.listeners.push(callback);

    return () => {
      const index = this.listeners.indexOf(callback);
      if (index > -1) {
        this.listeners.splice(index, 1);
      }
    };
  }

  /**
   * Get default theme
   * @private
   * @returns {object} Default theme object
   */
  getDefaultTheme() {
    return {
      primaryColor: '#1e3c72',
      secondaryColor: '#2a5298',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      mode: 'light'
    };
  }
}
